import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { VestingTask } from '../../types/vesting-tasks.types';
import { useAppQuery } from '../use-app-query.hook';

export const useSharePlanGrantItems = ({
  companyId,
  sharePlanId,
}: {
  companyId: string;
  sharePlanId: string;
}) => {
  const queryClient = useQueryClient();
  const { data: approveHurdleGrants = [], isLoading } = useAppQuery<VestingTask[]>({
    queryKey: [QueryKey.GET_SHARE_PLAN_VESTING_TASKS, companyId, sharePlanId],
    queryFn: () =>
      ApiService.get({
        endpoint: BackendRoute.COMPANIES,
        routePath: [companyId, 'events', 'share-plans', sharePlanId, 'vesting-tasks'],
      }),
    enabled: !!companyId && !!sharePlanId,
  });

  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.GET_SHARE_PLAN_VESTING_TASKS] });
  }, [queryClient]);

  return {
    invalidateQuery,
    approveHurdleGrants,
    isLoading,
  };
};
